//
// VueJS + Addons
//
import Vue from 'vue';
import Vuetify from 'vuetify';
import VueCompositionAPI from '@vue/composition-api';
import Shepherd from 'shepherd.js';


Vue.config.productionTip = false;

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import { pt, en } from 'vuetify/lib/locale';
import { i18n, bindVuetify, tb, translateHeaders, translateSchema, translateNotificationTitle, translateNotificationSubtitle, translateHtml, translateUrl, translateServerMessage } from './i18n';

Vue.use(Vuetify);
const vuetify = new Vuetify({
    lang: { locales: { pt, en }, current: 'pt' },
});
bindVuetify(vuetify);

Vue.use(VueCompositionAPI);

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import { createInertiaApp, InertiaLink, InertiaHead } from '@inertiajs/inertia-vue';
Vue.component('inertia-link', InertiaLink);
Vue.component('inertia-head', InertiaHead);

import VueApexCharts from 'vue-apexcharts';
Vue.component('apex-charts', VueApexCharts);

import DatePickerMenu from './Components/Form/DatePickerMenu';
Vue.component('v-date-picker-menu', DatePickerMenu);

import HighchartsVue from 'highcharts-vue'
Vue.use(HighchartsVue)

import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

window.EventBus = new Vue();

//
// Store (Pinia)
//
import { createPinia, PiniaVuePlugin } from 'pinia';

Vue.use(PiniaVuePlugin);

const pinia = createPinia();

//
// Ray (debugging)
//
if (window.location.host === 'localhost') {
    const { Ray, ray } = require('node-ray/web');

    window.ray = ray;
    window.Ray = Ray;
}

//
// Mixins
//
import { formatDate, formatDateTime, formatPrice, formatIntegerPrice, formatDecimal,formatQuantity,setUpperCase } from '@/Mixins/Formatting';
import { showSuccess, showWarning, showError, clampValue, parseQuantity, validateInput, scrollDatatableToTop, getResponsiveDialogWidth, getResponsiveDialogHeight, setHeightByStringSize, isIOS, checkConnection } from '@/Mixins/HelperFunctions';

Vue.mixin({
    methods: {
        tb,
        tHeaders: translateHeaders,
        tSchema: translateSchema,
        tHtml: translateHtml,
        tUrl: translateUrl,
        tServer: translateServerMessage,
        tnTitle: translateNotificationTitle,
        tnSubtitle: translateNotificationSubtitle,
        setUpperCase,
        formatDate,
        formatDateTime,

        formatPrice,
        formatIntegerPrice,

        formatDecimal,
        formatQuantity,

        showSuccess,
        showWarning,
        showError,
        clampValue,
        validateInput,
        parseQuantity,
        getResponsiveDialogWidth,
        getResponsiveDialogHeight,
        setHeightByStringSize,
        isIOS,
        scrollDatatableToTop,
        checkConnection
    },
});

//
// Bootstrap (InertiaJS)
//
import PublicLayout from './Layouts/PublicLayout';

const files = require.context('./Components', true, /\.vue|\.js$/i);
files.keys().map((key) => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

createInertiaApp({
    resolve: (name) => {
        const page = require(`./Pages/${name}`).default;
        page.layout = page.layout || PublicLayout;
        return page;
    },
    setup: ({ el, app, props }) => {
        new Vue({
            vuetify,
            i18n,
            pinia,
            render: (h) => h(app, props),
        }).$mount(el);
    },
});

//
// Tawk Chat
//
import TawkMessengerVue from '@tawk.to/tawk-messenger-vue-2';
import { getStringSize } from './Mixins/HelperFunctions';

Vue.use(TawkMessengerVue, {
    propertyId: process.env.MIX_TAWK_CHAT_PROPERTY_ID,
    widgetId: process.env.MIX_TAWK_CHAT_WIDGET_ID,
    customStyle: {
        visibility: {
            desktop: {
                position: 'br',
                xOffset: -2,
                yOffset: 60,
            },
            mobile: {
                position: 'br',
                xOffset: -2,
                yOffset: 30,
            },
        },
    },
});

Shepherd.on('complete', (data) => {
    window.EventBus.$emit('remove-tutorial-overlay');

    const shepherdData = {
        page: data?.tour?.options?.tourName,
    };

    window.axios.post('/api/tutorials', shepherdData).catch(() => {
        console.log(`${shepherdData.page} - Falha a submeter a confirmação de visualização da demonstração`);
    });
});

Sentry.init({
    Vue,
    dsn: process.env.MIX_SENTRY_VUE_DSN,
    integrations: [
        new BrowserTracing({
            tracePropagationTargets: ['myprovet.pt', /^\//], // TODO: set the prod address
        }),
    ],
    environment: process.env.MIX_SENTRY_ENVIRONMENT,
    tracesSampleRate: process.env.MIX_SENTRY_TRACES_SAMPLE_RATE,
    ignoreErrors: ['ResizeObserver loop limit exceeded', 'ResizeObserver loop completed with undelivered notifications.'],
    trackComponents: true,
    logErrors: true,
});
